export default "__VITE_ASSET__p1rkX_tJ__"